<script setup lang="ts">
import type { Image } from 'sanity';
import { computed, type Component } from 'vue';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string
    person?: any,
    size?: 1 | 2 | 3 | 4 | 5,
    class?: string,
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  person: props.block?.person,
  size: props.block.size,
}));

</script>

<template>
  <div :class="['wrapper wrapper--content', props.block?.class]">
    <component :is="props.config?.innerComponent" v-bind="data" />
  </div>
</template>